import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;

import { getColor, getSize, MathEnabledTextComponent, styleVariables, PrimaryButton, RichTextEditor, SecondaryButton, TextToHTMLTransformerComponent } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { Space, Tooltip } from 'antd';
import { useMemo, useState, useCallback, useEffect } from 'react';
import { EditOutlined } from '@ant-design/icons';
import { AnswerType, SubmissionScore } from '@module/assignment';
import { ScoreInput, GradingTagComponent, QuestionTypeTagComponent } from '@module/assignment-components';
import { useQuestionContext } from '../../question-v2/core';
import { QuestionType } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var QuestionCard = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n"])), function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 0;
  }

  return '25px 32px';
}, function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 'none';
  }

  return "0px 3px 6px rgba(0, 0, 0, 0.12)";
}, function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 'transparent';
  }

  return styleVariables.colors.gray1;
}, styleVariables.colors.gray4);
var QuestionContent = styled(MathEnabledTextComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  margin-bottom: ", ";\n\n  p {\n    margin: 0;\n  }\n  img {\n    max-width: 100%;\n  }\n"])), styleVariables.colors.gray13, getSize('padding12'));
var TitleArea = styled(Space)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var Content = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
var StyledExplanationWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", ";\n\n  width: 100%;\n  padding: ", ";\n  background-color: #faf8fc;\n  border-radius: ", ";\n  border: 1px solid #e2e8f0;\n"])), getSize('padding4'), getSize('padding12'), getSize('radiusSm'));
var StyledExplanationIconWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  flex-shrink: 0;\n"])), getSize('padding24'), getSize('padding24'));
var StyledExplanationTitle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.5;\n  margin-bottom: ", ";\n"])), getSize('typo16'), getSize('padding8'));
var StyledExplanationContent = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding4'));
var StyledExplanationDescription = styled(MathEnabledTextComponent)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: ", ";\n  letter-spacing: 0;\n  line-height: 1.6;\n  /* Set default color only for elements without inline styles */\n  color: #475569;\n\n  /* Preserve inline styles - inline styles have higher specificity */\n  /* Elements with inline styles will use their inline color */\n\n  img {\n    max-width: 100%;\n    border-radius: ", ";\n    margin: ", " 0;\n  }\n\n  strong {\n    font-weight: 600;\n    /* Only apply default color if no inline style */\n    &:not([style*='color']) {\n      color: #1e293b;\n    }\n  }\n\n  /* Preserve color for elements with inline styles */\n  span[style*='color'],\n  p[style*='color'],\n  div[style*='color'],\n  strong[style*='color'],\n  em[style*='color'],\n  u[style*='color'] {\n    /* Inline color will take precedence due to inline style specificity */\n  }\n\n  a {\n    color: ", ";\n    text-decoration: underline;\n\n    &:hover {\n      color: #6d28d9;\n    }\n  }\n"])), getSize('typo14'), getSize('radiusSm'), getSize('padding12'), getColor('fillIntActive'));
var StyledHeaderArea = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var StyledButtonSpace = styled(Space)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: end;\n"])));
var StyledCommentCard = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  overflow: hidden;\n  padding: ", ";\n"])), styleVariables.colors.gray10, getSize('radiusSm'), styleVariables.colors.gray2, getSize('padding12'));
var StyledCommentCardHeader = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: ", ";\n"])), getSize('padding12'));
var StyledCommentCardTitle = styled.span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), getSize('typo16'), styleVariables.font.fontWeightStrong, styleVariables.colors.gray12);
var StyledCommentContentBlock = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  min-height: 80px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n"])), styleVariables.colors.gray1, getSize('radiusS'), getSize('padding16'));
var StyledCommentCardBody = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: 1.7;\n  color: ", ";\n  white-space: pre-wrap;\n  word-break: break-word;\n"])), getSize('typo14'), styleVariables.colors.gray12);
var StyledCommentCardEditorBody = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  border-radius: ", ";\n\n  /* Override RichTextEditor toolbar background to be white */\n  & > div:first-child > div:first-child {\n    background-color: ", " !important;\n  }\n"])), getSize('gap8'), getSize('radiusS'), styleVariables.colors.gray1);

var canEditComment = function canEditComment(isAssignmentEnded, disabled, isOnGradingProcess) {
  return !disabled && !isOnGradingProcess;
};

var StyledQuestionNumberTag = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background: #dbeafe;\n  border-radius: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  user-select: none;\n"])), getSize('padding4'), getSize('padding8'), getSize('typo14'), getSize('typo20'), getColor('fillIntActive'), getSize('radiusS'));
var StyledOnGradingText = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  font-style: italic;\n  color: ", ";\n  font-size: 14px;\n  line-height: 20px;\n  padding: 4px 8px;\n  text-align: center;\n"])), styleVariables.colors.gray10);

var isValidScore = function isValidScore(value) {
  return value !== undefined && value !== SubmissionScore["default"].value;
};

var getNormalizedScoreValue = function getNormalizedScoreValue(answer, value) {
  if ((answer === null || answer === void 0 ? void 0 : answer.type) === AnswerType.FillInBlank) {
    var fillInBlankAnswer = answer;
    var totalScore = fillInBlankAnswer.answers.reduce(function (sum, answerBlank) {
      return sum + (answerBlank.score || 0);
    }, 0);
    return isValidScore(totalScore) ? totalScore : null;
  }

  return isValidScore(value) ? value : null;
};

var getScoreInputState = function getScoreInputState(value) {
  if (!isValidScore(value)) {
    return {
      active: false,
      danger: false
    };
  }

  return {
    active: value > 0,
    danger: value === 0
  };
};

var isExplanationEmpty = function isExplanationEmpty(explanation) {
  if (!explanation) return true;
  var trimmedExplanation = explanation.trim();
  if (!trimmedExplanation) return true;
  var hasImage = /<img[^>]+>/gi.test(trimmedExplanation);
  if (hasImage) return false; // Not empty if has image

  var contentWithoutWhitespace = trimmedExplanation.replace(/\s/g, '');
  var htmlTagRegex = /(<([^>]+)>)/gi;
  var formattedContentWithoutHTML = contentWithoutWhitespace.replaceAll(htmlTagRegex, '');
  return !formattedContentWithoutHTML || formattedContentWithoutHTML.length === 0;
};

export var BaseQuestionGradingComponent = function BaseQuestionGradingComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions,
      children = _ref.children;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question; // Destructure states


  var label = states.label,
      isSkipped = states.isSkipped,
      _states$isEssayQuesti = states.isEssayQuestion,
      isEssayQuestion = _states$isEssayQuesti === void 0 ? false : _states$isEssayQuesti,
      hasAnswer = states.hasAnswer,
      isCorrect = states.isCorrect,
      isAllQuestionAnswersGraded = states.isAllQuestionAnswersGraded,
      _states$isResponderVi = states.isResponderView,
      isResponderView = _states$isResponderVi === void 0 ? false : _states$isResponderVi,
      _states$isShowingScor = states.isShowingScoreInput,
      isShowingScoreInput = _states$isShowingScor === void 0 ? true : _states$isShowingScor,
      _states$disabled = states.disabled,
      disabled = _states$disabled === void 0 ? false : _states$disabled,
      value = states.value,
      icon = states.icon,
      answer = states.answer,
      _states$isShowingExpl = states.isShowingExplanation,
      isShowingExplanation = _states$isShowingExpl === void 0 ? true : _states$isShowingExpl,
      _states$hasCustomDesc = states.hasCustomDescription,
      hasCustomDescription = _states$hasCustomDesc === void 0 ? false : _states$hasCustomDesc,
      _states$isShowComment = states.isShowComments,
      isShowComments = _states$isShowComment === void 0 ? false : _states$isShowComment,
      isAssignmentEnded = states.isAssignmentEnded,
      isCommentLoading = states.isCommentLoading,
      isOnGradingProcess = states.isOnGradingProcess,
      editorLabels = states.editorLabels; // Destructure actions

  var submitGradeAnswer = actions.submitGradeAnswer,
      onComment = actions.onComment;

  var _useState = useState(false),
      isCommentEditing = _useState[0],
      setIsCommentEditing = _useState[1];

  var _useState2 = useState(''),
      commentContent = _useState2[0],
      setCommentContent = _useState2[1];

  var _useState3 = useState(false),
      wasLoading = _useState3[0],
      setWasLoading = _useState3[1];

  useEffect(function () {
    if (isCommentLoading) {
      setWasLoading(true);
    }

    if (wasLoading && !isCommentLoading) {
      setIsCommentEditing(false);
      setWasLoading(false);
    }
  }, [isCommentLoading, wasLoading]);
  var questionTypeLabel = useMemo(function () {
    return {
      singleChoiceQuestion: label.singleChoiceQuestion,
      fillInBlankQuestion: label.fillInBlankQuestion,
      matchingQuestion: label.matchingQuestion,
      essayQuestion: label.essayQuestion,
      multipleChoiceQuestion: label.multipleChoiceQuestion
    };
  }, [label]);
  var gradingTagLabel = useMemo(function () {
    return {
      skipped: label.skipped,
      correct: label.correct,
      inCorrect: label.inCorrect,
      customGrade: label.colorStatusCustomGrade,
      colorStatusCorrect: label.colorStatusCorrect,
      colorStatusIncorrect: label.colorStatusIncorrect
    };
  }, [label]);

  var renderExplanation = function renderExplanation() {
    if (question.explanation === undefined || !isShowingExplanation) {
      return null;
    }

    var hasExplanationContent = !isExplanationEmpty(question.explanation);

    if (!hasExplanationContent) {
      return null;
    }

    return /*#__PURE__*/_jsxs(StyledExplanationWrapper, {
      children: [/*#__PURE__*/_jsx(StyledExplanationIconWrapper, {
        children: icon.lightBulb
      }), /*#__PURE__*/_jsxs(StyledExplanationContent, {
        children: [/*#__PURE__*/_jsx(StyledExplanationTitle, {
          children: label.explanation
        }), /*#__PURE__*/_jsx(StyledExplanationDescription, {
          value: question.explanation
        })]
      })]
    });
  };

  var renderResponderGradingState = function renderResponderGradingState() {
    return /*#__PURE__*/_jsx(StyledOnGradingText, {
      children: /*#__PURE__*/_jsx("i", {
        children: label.isOnGrading
      })
    });
  };

  var renderDisabledScoreInput = function renderDisabledScoreInput() {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: label.disabledScoreInputText,
      children: /*#__PURE__*/_jsx(ScoreInput, {
        questionScore: question.score,
        label: label,
        submitScore: submitGradeAnswer,
        value: getNormalizedScoreValue(answer, value),
        disabled: true
      })
    });
  };

  var renderActiveScoreInput = function renderActiveScoreInput() {
    var _getScoreInputState = getScoreInputState(value),
        active = _getScoreInputState.active,
        danger = _getScoreInputState.danger;

    return /*#__PURE__*/_jsx(Space, {
      children: /*#__PURE__*/_jsx(ScoreInput, {
        questionScore: question.score,
        label: label,
        submitScore: submitGradeAnswer,
        value: getNormalizedScoreValue(answer, value),
        active: active,
        danger: danger,
        disabled: disabled
      })
    });
  };

  var renderScoreInput = function renderScoreInput() {
    if (!isShowingScoreInput) {
      return null;
    } // TODO: Check if practice assignment -> hide.


    if (isResponderView && value === SubmissionScore["default"].value) {
      return renderResponderGradingState();
    }

    if (disabled && label.disabledScoreInputText) {
      return renderDisabledScoreInput();
    }

    return renderActiveScoreInput();
  };

  var notAllowToCommentQuestionTypes = useMemo(function () {
    return [QuestionType.FillInBlank, QuestionType.Matching];
  }, []);
  var handleCancelComment = useCallback(function () {
    setIsCommentEditing(false);
    setCommentContent('');
  }, []);
  var handleSaveComment = useCallback(function (textValue) {
    onComment === null || onComment === void 0 ? void 0 : onComment(textValue);
  }, [onComment]);
  var handleEditClick = useCallback(function () {
    if (!disabled) {
      var allowToCommentAnswer = answer;
      setCommentContent((allowToCommentAnswer === null || allowToCommentAnswer === void 0 ? void 0 : allowToCommentAnswer.comment) || '');
      setIsCommentEditing(true);
    }
  }, [disabled, answer]);

  var renderCommentSection = function renderCommentSection() {
    if (notAllowToCommentQuestionTypes.includes(question.type)) return null;
    if (!isShowComments) return null;
    var allowToCommentAnswer = answer;
    var shouldShowEditButton = !isCommentEditing && !isResponderView && !disabled;

    var renderBody = function renderBody() {
      if (isCommentEditing) {
        var canEdit = canEditComment(isAssignmentEnded, disabled, isOnGradingProcess);
        return /*#__PURE__*/_jsxs(StyledCommentCardEditorBody, {
          children: [/*#__PURE__*/_jsx(RichTextEditor, {
            placeholder: label.enterComment,
            content: commentContent,
            onChange: setCommentContent,
            disabled: !canEdit || isCommentLoading,
            scrollable: true,
            editorLabels: editorLabels,
            hideMath: true
          }), /*#__PURE__*/_jsxs(StyledButtonSpace, {
            align: "baseline",
            children: [/*#__PURE__*/_jsx(SecondaryButton, {
              onClick: handleCancelComment,
              disabled: isCommentLoading,
              children: label.cancel
            }), /*#__PURE__*/_jsx(PrimaryButton, {
              size: "middle",
              onClick: function onClick() {
                return handleSaveComment(commentContent);
              },
              disabled: commentContent === (allowToCommentAnswer === null || allowToCommentAnswer === void 0 ? void 0 : allowToCommentAnswer.comment) || isCommentLoading,
              loading: isCommentLoading,
              children: label.save
            })]
          })]
        });
      }

      var commentValue = isResponderView || disabled ? allowToCommentAnswer !== null && allowToCommentAnswer !== void 0 && allowToCommentAnswer.isEmptyComment() ? '' : allowToCommentAnswer === null || allowToCommentAnswer === void 0 ? void 0 : allowToCommentAnswer.comment : allowToCommentAnswer === null || allowToCommentAnswer === void 0 ? void 0 : allowToCommentAnswer.comment;
      return /*#__PURE__*/_jsx(StyledCommentContentBlock, {
        children: /*#__PURE__*/_jsx(StyledCommentCardBody, {
          children: commentValue ? TextToHTMLTransformerComponent({
            value: commentValue
          }) : /*#__PURE__*/_jsx("span", {
            style: {
              color: styleVariables.colors.gray10
            },
            children: label.noComment
          })
        })
      });
    };

    return /*#__PURE__*/_jsxs(StyledCommentCard, {
      children: [/*#__PURE__*/_jsxs(StyledCommentCardHeader, {
        children: [/*#__PURE__*/_jsx(StyledCommentCardTitle, {
          children: label.teacherComment
        }), shouldShowEditButton && /*#__PURE__*/_jsx(PrimaryButton, {
          icon: /*#__PURE__*/_jsx(EditOutlined, {}),
          size: "small",
          onClick: handleEditClick,
          loading: isCommentLoading,
          disabled: disabled,
          children: label.edit || "Edit"
        })]
      }), renderBody()]
    });
  };

  return /*#__PURE__*/_jsxs(QuestionCard, {
    isSkipped: isSkipped,
    isEssayQuestion: isEssayQuestion,
    hasAnswer: hasAnswer,
    isCorrect: isCorrect,
    direction: "vertical",
    size: "middle",
    id: "ga_".concat(question.id),
    isAllQuestionAnswersGraded: isAllQuestionAnswersGraded,
    children: [/*#__PURE__*/_jsxs(StyledHeaderArea, {
      children: [/*#__PURE__*/_jsxs(TitleArea, {
        children: [/*#__PURE__*/_jsxs(StyledQuestionNumberTag, {
          children: [label.question, " ", question.titleIndex]
        }), /*#__PURE__*/_jsx(QuestionTypeTagComponent, {
          questionType: question.type,
          icon: icon,
          label: questionTypeLabel
        }), /*#__PURE__*/_jsx(GradingTagComponent, {
          isSkipped: isSkipped,
          hasAnswer: hasAnswer,
          isCorrect: isCorrect,
          score: answer && 'score' in answer ? answer.score : undefined,
          hasGraded: answer && 'hasGraded' in answer ? answer.hasGraded() : false,
          label: gradingTagLabel
        })]
      }), renderScoreInput()]
    }), !hasCustomDescription && /*#__PURE__*/_jsx(QuestionContent, {
      value: question.description
    }), /*#__PURE__*/_jsx(Content, {
      children: children
    }), isShowingExplanation && renderExplanation(), renderCommentSection()]
  });
};